import {
  SearchPanelNavbarContainer,
  StyledNavBar,
} from "./styles";
import { SearchPanelBase } from "../searchPanel/SearchPanelBase";
import { memo } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { DownOutlined } from "ui";
import {
  HIDE_ROUTES,
  DISPLAY_SEARCH_NAV_BAR_ROUTES,
  ROUTE_URLS,
} from "../../constants/consts";
import { BaseBreadCrumbs } from "../breadcrumbs/Breadcrumbs";
import { LanguageSwitcher } from "../languageSwitcher/languageSwitcher";
import { CartBlock } from "./components/cartBlock";
import NavButtonPerson from "./NavButtonPerson";
import {
  getSession,
  getSessionUserCompany,
  getSessionUserRole,
} from "../../api/sessionManagement";
import Avatar from "../../images/avatar.png";
import "./Navbar.sass";

export const Navbar = memo(() => {
  const location = useLocation();
  const company = getSession() ? getSessionUserCompany() || "User" : "User";
  const role = getSession() ? getSessionUserRole() || "System Manager" : "System Manager";
  const displayComponentSearchPanel = DISPLAY_SEARCH_NAV_BAR_ROUTES.some(
    (element) => matchPath(element, location.pathname)
  );
  const isCatalogRoute = [
    ROUTE_URLS.CATALOG,
    ROUTE_URLS.CATALOG_CATEGORY,
  ].some((element) => matchPath(element, location.pathname));
  const hideComponentNavBar = HIDE_ROUTES.some((element) =>
    matchPath(element, location.pathname)
  );
  const navClassName = [
    "navbar-shell",
    "cremaNavbar",
    isCatalogRoute ? "cremaNavbar--sticky" : "",
    displayComponentSearchPanel
      ? "cremaNavbar--search"
      : "cremaNavbar--breadcrumbs",
  ].join(" ");

  return (
    <>
      {!hideComponentNavBar && (
        <StyledNavBar className={navClassName}>
          <div className="cremaNavbar__left">
            <div className="cremaNavbar__content">
              {!displayComponentSearchPanel && <BaseBreadCrumbs />}
              {displayComponentSearchPanel && (
                <SearchPanelNavbarContainer className="cremaNavbar__searchPanel">
                  <SearchPanelBase />
                </SearchPanelNavbarContainer>
              )}
            </div>
          </div>

          <div className="cremaNavbar__right">
            <LanguageSwitcher
              showButtons={false}
              compact
              className="cremaNavbar__languageTrigger"
            />
            <NavButtonPerson
              triggerClassName="cremaNavbar__userTrigger"
              menuClassName="cremaNavbar__userMenu"
              triggerContent={
                <div className="mainSidebar__userBlock">
                  <img src={Avatar} alt="User avatar" className="mainSidebar__userAvatar" />
                  <div className="mainSidebar__userInfo">
                    <span className="mainSidebar__userName" title={company}>
                      {company}
                    </span>
                    <span className="mainSidebar__userRole" title={role}>
                      {role}
                    </span>
                  </div>
                  <DownOutlined className="mainSidebar__userChevron" />
                </div>
              }
            />
            <CartBlock />
          </div>
        </StyledNavBar>
      )}
    </>
  );
});
